<template>
  <div
    ref="buttonContainer"
    class="button-container"
    :class="`${props.disable ? 'disable' : ''}`"
    :style="{
      '--x-offset': `-${offsetOverride ? 0 : offset}px`,
      '--btn-w-hover': `${button?.clientWidth - 15}px`,
    }">
    <a
      v-if="props.url"
      ref="button"
      :class="`button ${props.theme}`"
      :href="props.url"
      :target="props.target">
      <span class="text">
        {{ props.text }}
        <span class="text-inner">
          {{ props.text }}
        </span>
      </span>
    </a>
    <button
      v-else-if="!props.url && props.func"
      ref="button"
      :class="`button ${props.theme}`"
      @click="func(props.args)">
      <span class="text">
        {{ props.text }}
        <span class="text-inner">
          {{ props.text }}
        </span>
      </span>
    </button>
    <div
      v-else
      ref="button"
      :class="`button cursor-pointer ${props.theme}`">
      <span class="text">
        {{ props.text }}
        <span class="text-inner">
          {{ props.text }}
        </span>
      </span>
    </div>
    <div class="absolute top-1"></div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const props = defineProps({
  text: String,
  url: String,
  target: String,
  theme: {
    type: String,
    default: '',
    validator: (value) => ['white-purple', 'purple-white', ''].includes(value),
  },
  offsetOverride: {
    type: Boolean,
    default: false,
  },
  disable: {
    type: Boolean,
    default: false,
  },
  func: Function,
  args: Number,
})

const buttonContainer = ref()
const button = ref()

const getOffset = () => {
  return (buttonContainer.value.clientWidth - button.value.clientWidth) / 2
}

const offset = ref(0)

onMounted(() => {
  offset.value = getOffset()
})
</script>

<style lang="scss">
.button-container {
  @apply min-w-[224px] max-w-[300px] py-2 flex items-center justify-center translate-x-[var(--x-offset)];
  &.disable {
    @apply pointer-events-none opacity-40 grayscale;
  }
  .button {
    @apply overflow-hidden border-2 border-solid border-lm_white bg-lm_white min-w-[224px] px-[28px] py-[17px] pb-[13px] w-fit h-fit flex items-center justify-center text-center text-xl not-italic font-normal leading-[normal] tracking-[0.2px] transition-all duration-300 ease-in-out;

    .text {
      @apply relative transition-all duration-300 ease-in-out;

      &-inner {
        @apply left-0 -top-[200%] w-full absolute;
      }
    }

    &.white-purple {
      @apply bg-lm_white border-lm_purple;
    }

    &.purple-white {
      @apply bg-lm_purple border-lm_purple;

      .text,
      .text-inner {
        @apply text-white;
      }
    }
  }

  @media (min-width: 768px) {
    &:hover {
      .button {
        @apply min-w-[var(--btn-w-hover)];

        .text {
          @apply translate-y-[200%];
        }
      }
    }
  }
}
</style>
